import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';
import DescriptionIcon from '@material-ui/icons/Description';
import FolderIcon from '@material-ui/icons/Folder';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Colors from '../../../config/colors';
import { findAssetsToDelete } from '../../../services/entities/assets';
import { deleteAsset, deleteAssetFolder, displayAsset } from '../../../store/assets/actions';
import { getAssets } from '../../../store/assets/selectors';
import { handleSnackBar, setApiResponseCode, setApiResponseMessage, setFocusElement, toggleRightDrawer } from '../../../store/global/actions';
import { getReRender, getRightDrawerStatus } from '../../../store/global/selectors';
import { ApiResponseAlert } from '../alerts/ApiResponseAlert';
import DeleteAssetAlert from '../alerts/DeleteAssetAlert';
import UploadAsset from './UploadAsset';

const useStyles = makeStyles({
    assetFolder: {
        backgroundColor: Colors.primary,
        color: '#fff',
        '&:hover': {
            backgroundColor: Colors.primary,
        }
    },
    commonFolder: {
        backgroundColor: '#fff',
        color: '#000'
    },
    columnContainer: {
        paddingRight: '7px',
    },
    divider: {
        borderRight: '2px solid #b5b6b7',
    }
});

export default function FileList({ setDisplayFile, setDisplayItem, setDisplayIcon, column, setColumnOne, setColumnTwo, setColumnThree, assets, setColumnThreeId, setColumnTwoId, setSelectedItem, setImageHeight, setImageLoading, selectedIds,selectedItem }) {
   
    const classes = useStyles();
    const dispatch = useDispatch();
    const allAssets = useSelector(getAssets);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);
    const params = useParams();
    const { slug, id: blueprintId } = params;
    const [accesAlert, setAccessAlert] = useState(false)
    const [openAssetUploadModal, setOpenAssetUploadModal] = useState(false);
    const [selectedParent, setSelectedParent] = useState(undefined);
    const reRender = useSelector(getReRender);

    useEffect(() => {
        if(selectedItem && selectedItem?.type === 'file'){
            displayAsset(selectedItem, slug).then(resp => {
                setDisplayItem(resp)
                setImageLoading(false);
            })
        }
    }, [reRender]);
    
    const handleClick = (item, type, setAnchor) => {
        if (type === 'file') {
            setSelectedParent(item?.columnHeading ? item.parent : item._id);
            setOpenAssetUploadModal(true);
        }

        if (type === 'folder') {
            if (!rightDrawerStatus) dispatch(toggleRightDrawer());
            dispatch(setFocusElement({ id: null, type: 'assets_folder', parent: item?.columnHeading ? item.parent : item._id }))
        }

        if (type === 'delete') {
            if (item.type === 'file') {
                dispatch(deleteAsset(item)).then(res => {
                    if (res.status == true) {
                        setDisplayFile(false);
                        setDisplayIcon(null);
                        dispatch(handleSnackBar({ open: true, message: 'File deleted', severity: 'success', }));
                    }
                    else if (res.code) {
                        if ([251, 252, 253, 254, 255].includes(res.code)) {
                            dispatch(setApiResponseMessage(res.message))
                            dispatch(setApiResponseCode(res.code))
                            setAccessAlert(true)

                        }
                    }
                    else {
                        dispatch(handleSnackBar({ open: true, message: 'File delete failed', severity: 'error', }));
                    }
                })
            }

            if (item.type === 'folder') {

                dispatch(handleSnackBar({ open: true, message: 'Directory deleting..', severity: 'info', }));


                const assetsToDelete = findAssetsToDelete({ assets: allAssets, item })

                dispatch(deleteAssetFolder(assetsToDelete, blueprintId, item)).then(res => {


                    if (res.status == true) {
                        dispatch(handleSnackBar({ open: true, message: 'Directory deleted', severity: 'success', }));
                        if (column === 'one') {

                            setColumnTwoId(null)
                            setColumnTwo(null)
                            if (setColumnThree) setColumnThree(null)
                            if (setColumnThreeId) setColumnThreeId(null)
                            setDisplayFile(null)
                            setDisplayIcon(null)
                            setDisplayItem(null)

                        }

                        if (column === 'two') {

                            if (setColumnTwoId) setColumnTwoId(null)
                            if (setColumnTwo) setColumnTwo(null)
                            if (setColumnThree) setColumnThree(null)
                            if (setColumnThreeId) setColumnThreeId(null)
                            setDisplayFile(null)
                            setDisplayIcon(null)
                            setDisplayItem(null)

                        }
                    }
                    else if (res.code) {
                        if ([251, 252, 253, 254, 255].includes(res.code)) {
                            dispatch(handleSnackBar({ open: false }));
                            dispatch(setApiResponseMessage(res.message))
                            dispatch(setApiResponseCode(res.code))
                            setAccessAlert(true)

                        }
                    }
                    else {
                        dispatch(handleSnackBar({ open: true, message: 'Directory delete failed', severity: 'error', }));
                    }

                });

                // dispatch(handleSnackBar({ open: false }));

            }

        }

        if (type === 'rename') {

            if (!rightDrawerStatus) dispatch(toggleRightDrawer());
            dispatch(setFocusElement({ id: null, type: 'assets_rename', parent: item?.columnHeading ? item.parent : item._id, item: item }))

        }

        if (type === 'file' || type === 'folder') {
            setSelectedItem(item);
            setDisplayFile(false)
            setDisplayItem(null)
            setDisplayIcon(null)
            if (item.type === 'folder' && column === 'one' && !item.columnHeading) {
                setColumnTwo('two');
                setColumnThree(null);
                setColumnTwoId(item._id)
            }
            if (item.type === 'folder' && column === 'two' && !item.columnHeading) {
                setColumnThree('three');
                setColumnThreeId(item._id);
            }
        }

        setAnchor(null);
    }



    const clickAction = (item) => {
        if (item._id == selectedItem?._id) {
            return;
        }
        setSelectedItem(item);
        setImageLoading(false)
        if (item.type === 'file') {

            const displayAllowed = ['.png', '.jpeg', '.jpg', '.mp4', '.avi', '.mov']
            const allowed = displayAllowed.some(char => item.assetName.toLowerCase().includes(char));

            if (allowed) {

                setImageLoading(true);
                setDisplayFile(true);

                displayAsset(item, slug).then(resp => {
                    setDisplayItem(resp)
                    setImageLoading(false);
                })
                setDisplayIcon(null)



            } else {
                setImageLoading(true);
                displayAsset(item, slug).then(resp => {
                    setDisplayItem(resp)
                    setImageLoading(false);
                })
             
                setDisplayIcon(item)
            }



        } else {
            setDisplayFile(false)
            setDisplayItem(null)
            setDisplayIcon(null)
        }

        if (item.type === 'folder' && column === 'one' && !item.columnHeading) {
            setColumnTwo('two');
            setColumnThree(null);
            setColumnTwoId(item._id)
        }
        if (item.type === 'file' && column === 'one') {
            setColumnTwo(null);
            setColumnThree(null);
        }
        if (item.type === 'folder' && column === 'two' && !item.columnHeading) {

            setColumnThree('three');
            setColumnThreeId(item._id);
        }

        if (item.type === 'file' && column === 'two') {

            setColumnThree(null);
        }

    }

    const onCloseAssetUploadModal = () => {
        setOpenAssetUploadModal(false);
        setSelectedParent(undefined);
    }


    return (
        <Grid item xs={12} style={{ height: '100%' }} className={`${classes.columnContainer} ${column !== 'three' && classes.divider}`}>

            {assets?.length > 0 ? assets?.map((item, index) =>
                <List component="nav" aria-label="main mailbox folders" style={{ paddingTop: 0, paddingBottom: 0 }} onClick={() => clickAction(item)} >

                    <ListItem data-ui-tour-id={`asset-list-item-${index}`} className={item?.columnHeading ? classes.assetFolder : classes.commonFolder} button selected={(selectedIds.includes(item._id) && item._id !== null) ? true : false} key={item._id} /*style={{backgroundColor: (clickedItems.includes(item._id) && item._id !== null)? "#4791DB" : "primary" }}*/>

                        <ListItemIcon>
                            {item.type === 'folder' && !item.columnHeading && <FolderIcon />}
                            {item.type === 'file' && <DescriptionIcon />}
                        </ListItemIcon>

                        <ListItemText primary={item.assetName} />

                        <MoreOptions item={item} tourId={`asset-option-${index}`} isIcons={item?.assetName === "icons" && item?.parent === "null"} handleClick={handleClick} column={column} />

                    </ListItem>

                </List>)
                :
                <List >
                    <ListItem disabled={true} >
                        <ListItemText primary={"Directory is empty"} />
                    </ListItem>
                </List>
            }
            {accesAlert && <ApiResponseAlert />}
            {openAssetUploadModal && <UploadAsset parent={selectedParent} onClose={onCloseAssetUploadModal}/>}

        </Grid>
    )
}


const MoreOptions = ({ item, handleClick, column, isIcons, tourId }) => {


    const [anchor, setAnchor] = useState(null);
    const [deleteItem, setDeleteItem] = useState(null);
    const handleClose = () => setAnchor(null);
    const onClickOptions = (event) => { setAnchor(event.currentTarget) };
    const open = Boolean(anchor);

    const handleDelete = () => {
        setDeleteItem(null);
        handleClick(deleteItem, 'delete', setAnchor);
    }

    return (

        <>
            <Icon color="inherit" data-ui-tour-id={tourId} onClick={onClickOptions} id="create_upload">
                <MoreVertIcon title={"Create/Upload"} />
            </Icon>

            <Popover
                id='simple-node-options-popover'
                open={open}
                anchorEl={anchor}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <List id={`${item.assetName}_options`}>
                    {column !== 'three' && ((column === 'two' && item.columnHeading) || (column === 'one')) && item.type === 'folder' && !isIcons &&<ListItem button style={{ cursor: 'pointer', paddingTop: 0, paddingBottom: 0 }} onClick={(e) => handleClick(item, 'folder', setAnchor)} key={item}>
                        <ListItemText primary={"Create Directory"} />
                    </ListItem>}

                    {item.type === 'folder' && <ListItem button style={{ cursor: 'pointer', paddingTop: 0, paddingBottom: 0 }} onClick={(e) => handleClick(item, 'file', setAnchor)} >
                        <ListItemText primary={"Upload File"} />
                    </ListItem>}

                    {item._id !== null && <ListItem button style={{ cursor: 'pointer', paddingTop: 0, paddingBottom: 0 }} onClick={(e) => handleClick(item, 'rename', setAnchor)} >
                        <ListItemText primary={"Rename"} />
                    </ListItem>}

                    {item._id !== null &&
                    <ListItem button style={{ cursor: 'pointer', paddingTop: 0, paddingBottom: 0 }} onClick={(e) => { setDeleteItem(item) }} >
                        <ListItemText primary={"Delete"} />
                    </ListItem>
                    }
 
                </List>


            </Popover>

            {deleteItem !== null && <DeleteAssetAlert asset={deleteItem} onDelete={handleDelete} onClose={() => setDeleteItem(null)} />}
        </>
    )
}
